import * as React from "react";

export const HowItWorks: React.FC<{
  title?: string;
  subtitle?: string;
  steps?: Array<{ num: number; title: string; text: string }>;
  className?: string;
}> = ({
  title = "See How Simple It Is",
  subtitle = "Our streamlined process makes camera picking wholesale effortless",
  steps = [
    { num: 1, title: "Book a Time", text: "Choose a slot that suits you for live cam picking" },
    { num: 2, title: "Join Video Meeting", text: "Pick your vintage pieces on camera in real time" },
    { num: 3, title: "Place Your Order", text: "Confirm quantities, checkout, and get fast dispatch" }
  ],
  className,
}) => {
  return (
    <section className={`py-12 md:py-16 bg-[#0f2340]/80 ${className || ''}`}>
      <div className="mx-auto max-w-6xl px-4">
        <div className="text-center mb-6">
          <h2 className="text-2xl md:text-3xl font-bold text-white">{title}</h2>
          <p className="text-[#D8DAE5] mt-2">{subtitle}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          {steps.map((s) => (
            <div key={s.num} className="space-y-3">
              <div className="mx-auto w-14 h-14 rounded-full flex items-center justify-center text-white text-xl font-bold" style={{ backgroundColor: '#D9992B' }}>{s.num}</div>
              <h3 className="text-lg font-semibold text-white">{s.title}</h3>
              <p className="text-sm text-[#D8DAE5] max-w-xs mx-auto">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;




